module.exports = __webpack_public_path__ + "../static/img/suite_logo.b7f85a9f.png";